import { module } from 'angular';
import display from './builder/display.html';
import validate from './builder/validate.html';
import checkboxDirective from './checkbox.directive';

export default module('app')
	.directive('kformCheckbox', checkboxDirective)
	.run(/* @ngInject */ (
		/** @type {import('angular').ITemplateCacheService} */ $templateCache,
	) => {
		$templateCache.put('kform/components/checkbox/display.html', display);
		$templateCache.put('kform/components/checkbox/validate.html', validate);
	});
